// ============================================================================
// DatePicker.jsx — Corelia UI v1.2 (FormLayout + thème unifié)
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const DatePicker = ({
  label,
  labelPosition = "left",   // "left" | "top"
  labelWidth = null,
  align = "center",

  value,
  onChange,
  placeholder = "JJ/MM/AAAA",

  disabled = false,
  error = null,

  width = "100%",
  style = {},
  inputStyle = {},
}) => {
  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <input
        type="date"
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          width: "100%",
          minHeight: theme.form.field.minHeight,
          padding: `${theme.form.field.paddingV}px ${theme.form.field.paddingH}px`,

          fontFamily: theme.form.field.fontFamily,
          fontSize: theme.form.field.fontSize,
          fontWeight: theme.form.field.fontWeight,
          color: theme.form.field.color,

          borderRadius: theme.form.field.borderRadius,
          border: theme.form.field.border,
          backgroundColor: disabled
            ? theme.form.disabled.background
            : theme.form.field.background,

          outline: "none",
          transition: theme.form.field.transition,
          boxSizing: "border-box",

          ...(disabled
            ? { color: theme.form.disabled.color, cursor: "not-allowed" }
            : {}),

          ...(error
            ? { borderColor: theme.colors.text.danger }
            : {}),

          ...inputStyle,
        }}
        placeholder={placeholder}
        onFocus={(e) => {
          if (!disabled) {
            e.target.style.borderColor = theme.form.focus.borderColor;
            e.target.style.boxShadow = theme.form.focus.boxShadow;
          }
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error
            ? theme.colors.text.danger
            : theme.form.field.border.replace("1px solid ", "");
          e.target.style.boxShadow = "none";
        }}
      />

      {/* Message d’erreur */}
      {error && (
        <div
          style={{
            marginTop: 4,
            color: theme.colors.text.danger,
            fontSize: theme.fontSizes.sm,
            fontFamily: theme.form.label.fontFamily,
          }}
        >
          {error}
        </div>
      )}
    </FormLayout>
  );
};

export default DatePicker;
